angular.module('app').factory('ReportUtils', function (HttpHelper) {
    let fac = {
        getDefaultGridOptions: getDefaultGridOptions
    };
    function getDefaultGridOptions(report) {
        let defaultOptions = {
            columnDefs: report.columnDefs,
            defaultColDef: {
                resizable: true,
                sortable: true,
                filter: true,
                comparator: (a, b) => {
                    if (typeof a === 'string') {
                        return a.localeCompare(b);
                    }
                    else {
                        return (a > b ? 1 : (a < b ? -1 : 0));
                    }
                }
            }, // Default sorting changed from case-insensitive to case-sensitive. see https://github.com/ag-grid/ag-grid/issues/1795
            rowData: [],
            groupSuppressAutoColumn: false,
            autoGroupColumnDef: null,
            onModelUpdated: report.onModelUpdated,
            rowSelection: 'single',
            suppressMovableColumns: true, // Added because of ag-grid bug see https://github.com/ceolter/ag-grid/issues/965#issuecomment-225857509
            angularCompileRows: true,
            onRowDataChanged: report.onSizeChange,
            onGridSizeChanged: report.onSizeChange,
        };
        return defaultOptions;
    }
    return fac;
});
